import type { OnboardingFlow } from "@/platform/experiments/onboarding-flow"

let current: OnboardingFlow | null = null

export const setOnboardingFlow = (flow: OnboardingFlow | null): void => {
  current = flow
}

export const onboardingFlowFields = (): { onboarding_flow?: OnboardingFlow } => (current ? { onboarding_flow: current } : {})
